module.exports = __webpack_public_path__ + "img/DiGrano Curvas 01-1.a436da51.png";